<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<p class="center"><a id="page_ix"></a><em>To my sister Irene<br/>
    with love</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0003.vue?5fb5f271